import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import _FundFacts from './FundFacts';
import FundCommentary from './FundCommentary';
import Charts from './Charts';
import KeyDocuments from './KeyDocuments';
import Disclaimers from './Disclaimers';
import withColumns from './withColumns';
import {
    ChartStore,
    DataStore,
    EntityStore,
    RatingImageStore,
} from '../stores';
import { Chart } from '../models/configuration/chart/Chart';
import { FundManager } from '../models/entity';
import { FundCommentary as FundCommentaryConfig } from '../models/configuration/components/FundCommentary';
import { FundFacts } from '../models/configuration/components/FundFacts';
import { KeyDocProps } from '../models/configuration/components/KeyDocuments';
import { Theme } from '../models/Theme';

const FundFacts = withColumns(_FundFacts);

const FundCardColumns = styled<any, any>(
    'div',
    'fundCardColumns',
    'fundCardColumn'
)`
    ${propStyles};
`;

FundCardColumns.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    bgColor: 'white',
};

const FundCardMain = styled<any, any>('div', 'fundCardMain', 'fundCardColumn')`
    ${propStyles};
`;

FundCardMain.defaultProps = {
    flex: '0 1 100%',
    minWidth: '0',
    paddingX: ['sm', 'md', 'lg'],
    paddingY: ['sm', 'md', 'lg'],
};

const FundCardSidebar = styled<any, any>(
    'div',
    'fundCardSidebar',
    'fundCardColumn'
)`
    ${propStyles};
`;

FundCardSidebar.defaultProps = {
    width: '240px',
    flex: '0 0 auto',
    paddingX: ['md', 'lg'],
    paddingY: ['md', 'lg'],
};

interface FundCardColumnProps {
    theme?: Theme;
    chartStores?: Map<string, ChartStore>;
    dataStore?: DataStore;
    entityStore?: EntityStore;
    ratingImageComponent: React.ReactElement;
    keyDocuments: Array<KeyDocProps>;
    charts: Array<Chart>;
    fundManagers: Array<FundManager>;
    fundManagersComponent: React.ReactElement;
    fundCommentary: FundCommentaryConfig;
    hasFundCommentary: boolean;
    fundFacts: FundFacts;
    ratingImageStore: RatingImageStore;
}

@inject('dataStore', 'entityStore')
@observer
class FundCardColumn extends Component<FundCardColumnProps, any> {
    @computed
    get showSidebar() {
        const { fundManagers, ratingImageStore, keyDocuments } = this.props;
        return (
            fundManagers.length > 0 ||
            keyDocuments.length > 0 ||
            ratingImageStore.showComponent
        );
    }

    render() {
        const { showSidebar } = this;

        const {
            theme,
            entityStore,
            ratingImageComponent,
            keyDocuments,
            charts,
            fundManagersComponent,
            fundCommentary,
            hasFundCommentary,
            fundFacts,
            ratingImageStore,
        } = this.props;

        return (
            <FundCardColumns {...theme.FundCardColumns}>
                <FundCardMain {...theme.FundCardMain}>
                    {hasFundCommentary && (
                        <FundCommentary
                            showHeading={true}
                            fundCommentary={fundCommentary}
                        />
                    )}
                    {fundFacts && (
                        <FundFacts showHeading={true} fundFacts={fundFacts} />
                    )}
                    {charts && <Charts charts={charts} />}
                    <Disclaimers
                        disclaimers={entityStore.fundCardDisclaimers}
                        theme={{
                            ...theme,
                            DisclaimersList: theme.FundCardDisclaimersList,
                            DisclaimerListItem:
                                theme.FundCardDisclaimerListItem,
                            DisclaimerCharacter:
                                theme.FundCardDisclaimerCharacter,
                            DisclaimerContent: theme.FundCardDisclaimerContent,
                            DisclaimerReturnLink:
                                theme.FundCardDisclaimerReturnLink,
                        }}
                    />
                </FundCardMain>
                {showSidebar && (
                    <FundCardSidebar {...theme.FundCardSidebar}>
                        {ratingImageStore.ratingImagePosition ===
                            'aboveFundManager' && ratingImageComponent}
                        {fundManagersComponent}
                        {ratingImageStore.ratingImagePosition ===
                            'belowFundManager' && ratingImageComponent}
                        {keyDocuments.length > 0 && (
                            <KeyDocuments
                                showHeading={true}
                                keyDocuments={keyDocuments}
                            />
                        )}
                    </FundCardSidebar>
                )}
            </FundCardColumns>
        );
    }
}

export default withTheme(FundCardColumn) as any;



// WEBPACK FOOTER //
// ./src/Components/FundCardColumn.tsx